var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"erro"}},[_c('h1',[_vm._v("Ops! Parece que essa página não existe :(")])])}]

export { render, staticRenderFns }